import { render, staticRenderFns } from "./ReportInout.vue?vue&type=template&id=bfb6981a&"
import script from "./ReportInout.vue?vue&type=script&lang=ts&"
export * from "./ReportInout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports